// Kundenfeedback 16.10.2026 (Antworten auf 14.10., II): In der allgemeinen
// Fehlermeldung „… oder kontaktieren Sie den Support." soll „Support" direkt
// anklickbar sein. Die Meldungstexte bleiben unverändert (Aufrufer und Tests
// vergleichen sie); die Anzeige macht das Wort zum Link.

/** E-Mail-Adresse des Supports – Rückfall, wenn niemand angemeldet ist. */
export const SUPPORT_EMAIL = 'support@kars-connection.de'

export interface SupportMention {
  before: string
  word: string
  after: string
}

const SUPPORT_PATTERN = /((?:den|unseren|an den|an unseren)\s+)(Support)\b/

/** Zerlegt eine Meldung am Wort „Support"; null, wenn es nicht vorkommt. */
export function splitSupportMention (message: unknown): SupportMention | null {
  if (typeof message !== 'string' || !message) return null
  const match = SUPPORT_PATTERN.exec(message)
  const lead = match?.[1]
  const word = match?.[2]
  if (!match || lead === undefined || word === undefined) return null
  const start = match.index + lead.length
  return {
    before: message.slice(0, start),
    word,
    after: message.slice(start + word.length),
  }
}

/** Vorbelegung für „Fehler melden", damit der Support den Kontext kennt. */
export function supportReportPrefill (message: string, pageTitle = '') {
  const where = pageTitle.trim() ? ` (${pageTitle.trim()})` : ''
  return {
    title: `Fehlermeldung beim Arbeiten in KARS${where}`,
    description: `Angezeigte Meldung: „${message.trim()}“\n\nWas wollten Sie gerade tun? `,
  }
}

/** mailto-Link mit Betreff und Meldung (für nicht angemeldete Besucher). */
export function supportMailto (message: string): string {
  const subject = encodeURIComponent('Fehlermeldung in KARS')
  const body = encodeURIComponent(`Angezeigte Meldung: „${message.trim()}“\n\nWas wollten Sie gerade tun?\n`)
  return `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`
}
